module.exports = __webpack_public_path__ + "img/visualLogo1.c73db49.svg";